interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "NGN";
};

const NGN: Currency = Object.freeze({
  "displayName": "Nigerian Naira",
  "numericCode": 566,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "NGN",
  "symbol": "₦"
});

export { NGN };
